import React, { ReactNode } from 'react';
import { Paper, SxProps } from '@mui/material';
import { colors } from '../theme/palette';

type Props = {
  children?: ReactNode;
  sx?: SxProps;
};

export const ParentPaper = ({ children, sx }: Props) => {
  return (
    <Paper
      sx={{
        p: 0,
        '& .MuiPaper-root': {
          boxShadow: 0,
          '&:not(:last-child)': {
            pb: 0,
          },
          '&:not(:last-child):after': {
            content: '""',
            display: 'block',
            borderBottomStyle: 'solid',
            borderBottomWidth: { xs: 0.25, md: 1 },
            borderBottomColor: colors.darkBlue,
            opacity: { xs: 0.4, md: 0.2 },
            mt: 2.5,
            mb: 0.5,
          },
        },
        ...(sx ?? {}),
      }}
    >
      {children}
    </Paper>
  );
};
